import templateUrl from "./employers-directory-list.html";

import "./employers-directory-list.scss";

export const EmployersDirectoryListComponent = {
  bindings: {
    details: "<",
  },
  templateUrl,
  controller: class EmployersDirectoryListComponent {
    constructor($state, toastr, ModalService, EmployersDirectoryService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.modalService = ModalService;
      this.EmployersDirectoryService = EmployersDirectoryService;
    }

    $onInit() {
      this.getAllCities();
      this.getAllIndustries = [];
      this.employersDirectoryDetails = this.modifyEmployersDirectoryList(
        this.details
      );
      this.searchCompany;
      this.showAllCompanies = "";
      this.searchIndustry;
      this.showAllIndustries = "";
      this.typeOf = ""
      if (this.details) {
        for (let i = 0; i < this.details.length; i++) {
          let count = 0;
          for (let j = 0; j <= i; j++) {
            if (this.details[i].industries === this.details[j].industries) {
              count++;
            }
          }
          if (count === 1) {
            this.getAllIndustries.push(this.details[i].industries);
          }
        }
      }
    }

    modifyEmployersDirectoryList(employersDirectoyData) {
      return {
        data: employersDirectoyData,
        feature: "Employers Directory",
        config: {
          columnDefs: [
            {
              field: "displayName",
              enableSort: false,
              displayName: "COMPANY NAME",
              className: "col-lg-2 col-md-2 col-sm-3 text-break",
            },
            {
              field: "city",
              enableSort: false,
              displayName: "CITY",
              className: "col-lg-2 col-md-3 col-sm-4 text-break",
            },
            {
              field: "industries",
              enableSort: false,
              displayName: "INDUSTRY",
              className: "col-lg-3 col-md-2 col-sm-3 text-break",
            },

            {
              field: "numberOfEmployees",
              enableSort: false,
              displayName: "NUMBER OF EMPLOYEES",
              className: "col-lg-3 col-md-3 col-sm-3 text-break",
            },
            {
              type: "date",
              field: "updated_at",
              enableSort: true,
              format: "MM/dd/yyyy",
              displayName: "UPDATED AT",
              rowClass: "text-capitalize",
              className: "col-lg-2 col-md-2 col-sm-2",
            },
            {
              type: "View",
              field: "view",
              enableSort: false,
            },
            {
              type: "Edit",
              field: "edit",
              enableSort: false,
            },
            {
              type: "Delete",
              field: "delete",
              enableSort: false,
            },
          ],
        },
        // }
      };
    }

    onEdit(details) {
      this.$state.go("employersDirectoryEdit", {
        group_id: details.companyDirectoryId,
      });
    }

    onView(details) {
      this.$state.go("employersDirectoryView", {
        group_id: details.companyDirectoryId,
      });
    }

    getAllCities() {
      return this.EmployersDirectoryService.getAllCities().then((item) => {
        this.getAllCitiesData = item;
      });
    }

    handleCityChange(value, type) {
      this.typeOf = type
      this.showAllCompanies = value;
      this.details.industries = "";
      this.details.industry = "";
      if (value == "All") {
        this.employersDirectoryDetails = this.modifyEmployersDirectoryList(
          this.details
        );
      } else {
        let filteredCompanies = this.details.filter((item) => {
          if (value == item.city) {
            return item;
          }
        });
        if (value !== null) {
          this.employersDirectoryDetails =
            this.modifyEmployersDirectoryList(filteredCompanies);
          this.searchCompany =
            this.modifyEmployersDirectoryList(filteredCompanies);
        }
      }
    }

    handleIndustryChange(industry, type) {
      this.typeOf = type;
      this.showAllIndustries = industry;
      this.details.city = "";
      this.details.industries = "";
      if (industry == "All") {
        this.employersDirectoryDetails = this.modifyEmployersDirectoryList(
          this.details
        );
      } else {
        let filteredIndustries = this.details.filter((item) => {
              if(industry == item.industries) {
                  return item
              }
        });
        if(industry !== null) {
          this.employersDirectoryDetails =
            this.modifyEmployersDirectoryList(filteredIndustries);
          this.searchIndustry =  this.modifyEmployersDirectoryList(filteredIndustries);
        }
      }
    }

    handleSearch(value) {
      console.log(value)
      let searchByCompanyOrIndustry = this.typeOf === "city" ? this.searchCompany : this.searchIndustry;
      if ((this.showAllCompanies !== "All" || this.showAllIndustries !== "All") && searchByCompanyOrIndustry !== undefined) {
        let filteredCompany = searchByCompanyOrIndustry.data.filter((item) => {
          if (
            item.displayName
              .split(" ")
              .join("")
              .toLowerCase()
              .includes(value.toLowerCase())
          ) {
            return item;
          }
        });
        this.employersDirectoryDetails =
          this.modifyEmployersDirectoryList(filteredCompany);
      } else {
        let filteredCompany = this.details.filter((item) => {
          if (
            item.displayName
              .split(" ")
              .join("")
              .toLowerCase()
              .includes(value.toLowerCase())
          ) {
            return item;
          }
        });
        this.employersDirectoryDetails =
          this.modifyEmployersDirectoryList(filteredCompany);
      }
    }

    onDelete(data) {
      const bodyMsg = "Are you sure to delete this company?";
      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() {},
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });

      function _onDelete(details) {
        this.EmployersDirectoryService.deleteEmployersDirectoryIndividualGroup(
          details.companyDirectoryId
        )
          .then((_) => {
            this.toastr.success("Company deleted successfully!!");
            this.$state.reload();
          })
          .catch((error) => {
            this.toastr.error(error.data.errors.message);
          });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/employers-directory/employers-directory-list/employers-directory-list.component.js